import { Button, Flex } from 'dash-ui';
import styled from 'styled-components';

export const FlexWraper = styled(Flex)`
  width: 100%;
  flex-direction: row;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    gap: 2px;
  }
`;

export const ButtonWraper = styled(Button)`
  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    flex-grow: 1;
  }
`;

export const FileInputContainer = styled(Flex)`
  @media ${({ theme }) => theme.devices.mobile} {
    flex-grow: 1;
    width: 100%;
  }
`;
